// src/App.jsx

import React, { useState, useEffect } from 'react';
import ActivityManager from './ActivityManager.jsx';
import Login from './components/Login';
import { servicioAuth } from './services/firebaseService';

function App() {
  const [usuarioActual, setUsuarioActual] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    // Observar cambios de autenticación
    const unsubscribe = servicioAuth.observarCambiosAuth((usuario) => {
      if (usuario) {
        setUsuarioActual(usuario);
      } else {
        setUsuarioActual(null);
      }
      setCargando(false);
    });

    // Limpiar suscripción
    return () => unsubscribe();
  }, []);

  if (cargando) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Inicializando...</p>
        </div>
      </div>
    );
  }

  if (!usuarioActual) {
    return <Login onLoginExito={() => {}} />;
  }

  return <ActivityManager usuarioActual={usuarioActual} />;
}

export default App;
